import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@context/AuthContext";
import { LoadingCenter } from "@components/LoadingCenter";

export function ProtectedRoute() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <LoadingCenter />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/account" replace />;
  }

  return <Outlet />;
}
